import whatsappTemplateValidation from './whatsappTemplateValidation/en.json';
import odoo from './odoo/en.json';
import signupPartner from './signupPartner/en.json';
import mcp from './mcp/en.json';
import workspaceAssistant from './workspaceAssistant/en.json';
import simplifiedOnboarding from './simplifiedOnboarding/en.json';
import groupMembers from './groupMembers/en.json';
import workflowLibrary from './workflowLibrary/en.json';
import browserNotifications from './browserNotifications/en.json';
import reportIntegrity from './reportIntegrity/en.json';
import advancedFilters from './advancedFilters.json';
import aiCreditPackages from './aiCreditPackages/en.json';
import aiCreditHistory from './aiCreditHistory/en.json';
import aiCreditAnalytics from './aiCreditAnalytics/en.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import aiAgents from './aiAgents.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import businessHours from './businessHours/en.json';
import calendar from './calendar.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import dashboard from './dashboard.json';
import conversationActivity from './conversationActivity/en.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import generalInfo from './generalInfo.json';
import googleCalendar from './googleCalendar.json';
import googleSheets from './googleSheets.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import whatsappStories from './whatsappStories/en.json';
import whatsappReconnect from './whatsappReconnect/en.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import lifecycleStages from './lifecycleStages.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import replyPreview from './replyPreview/en.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import onboardingChecklist from './onboardingChecklist.json';
import paidAds from './paidAds.json';
import workspaceAlerts from './workspaceAlerts.json';
import yearInReview from './yearInReview.json';
import workspaceFiles from './workspaceFiles.json';
import workflowConditions from './workflowConditions/en.json';
import mobile from './mobile/en.json';

export default {
  ...whatsappTemplateValidation,
  ...odoo,
  ...mcp,
  ...aiCreditPackages,
  ...aiCreditHistory,
  ...aiCreditAnalytics,
  ...groupMembers,
  ...workspaceAssistant,
  ...workflowLibrary,
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...aiAgents,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...browserNotifications,
  ...businessHours,
  ...calendar,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...dashboard,
  ...conversationActivity,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...generalInfo,
  ...googleCalendar,
  ...googleSheets,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...whatsappStories,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...lifecycleStages,
  ...login,
  ...macros,
  ...report,
  ...reportIntegrity,
  ...replyPreview,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...signupPartner,
  ...sla,
  ...snooze,
  ...teamsSettings,
  ...whatsappTemplates,
  ...whatsappReconnect,
  ...contentTemplates,
  ...mfa,
  ...onboardingChecklist,
  ...simplifiedOnboarding,
  ...paidAds,
  ...workspaceAlerts,
  ...yearInReview,
  ...workspaceFiles,
  ...workflowConditions,
  ...mobile,
};
